import { Box, SimpleGrid, Text } from "@chakra-ui/react";
import { AirQualityDevice } from "../components/AirQualityDevice.jsx";
import { FireAlarm1 } from "../components/FireAlarmDevice.jsx";
import { useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { SignalRContext } from "./SignalRContext.jsx";

export const FreshWaterPumpStatusPage = () => {




  return (
    <Box mt="20px" ml="20px" mr="20px">
      <Text mb="20px" ml="5px" fontSize="sm"></Text>
      <SimpleGrid columns={[1, 1, 2, 2, 3, 3, 4]} spacing="10px">

        

      </SimpleGrid>
    </Box>
  );
};
